<div class="wrapper">
	<div class="login-form">
		<div class="title">
			<img [src]="'./assets/Username (Navy).svg' | resolveAsset" width="34" height="34" alt="username" style="margin-right: 12px" />
			<div>Sign In</div>
		</div>
		<div class="content">
			<app-input
				[formGroup]="loginForm"
				[autocomplete]="'username'"
				[controlName]="loginForm.get('username')"
				[input_label]="'Username or email'"
				[input_value]="loginForm.get('username').value"
				[isFocus]="true"
				(focusEvent)="focusEvent.emit($event)"
				(blurEvent)="blurEvent.emit($event)"
				[input_type]="isMobile ? 'email' : 'text'"
				[width]="'250px'"
				(onUpdate)="updateDemoUsername($event)"></app-input>
			<div
				class="input-password"
				[style.opacity]="loginData.demoLoginEnabled ? 1 : 0"
				[style.position]="loginData.demoLoginEnabled ? 'static' : 'absolute'">
				<app-input
					[autocomplete]="'password'"
					[formGroup]="loginForm"
					[isFocus]="inputFocusNumber === 2"
					[forceFocus$]="forceFocus$"
					(focusEvent)="focusEvent.emit($event)"
					(blurEvent)="blurEvent.emit($event)"
					[controlName]="loginForm.get('password')"
					[input_label]="'Password'"
					[input_type]="'password'"
					[width]="loginData.demoLoginEnabled ? '250px' : '0'"
					(onUpdate)="updateDemoPassword($event)"></app-input>
			</div>
			<div class="error" [style.position]="passwordError ? 'static' : 'absolute'" *ngIf="error$ | async as errorMessage">{{ errorMessage }}</div>
			<div class="already-message" *ngIf="schoolAlreadyText$ | async as alreadyText">{{ alreadyText }}</div>
			<div class="button" style="margin-top: 97px" *ngIf="!loginData.demoLoginEnabled">
				<app-gradient-button
					[disabled]="disabledButton"
					[size]="'medium'"
					[rightIcon]="!showSpinner ? './assets/Chevron Right (White).svg' : ''"
					[cursor]="'pointer'"
					[hoverColor]="'#FFFFFF'"
					[minWidth]="'90px'"
					[minHeight]="'30px'"
					[fontSize]="'14px'"
					(buttonClick)="!showSpinner ? checkEmail() : null"
					[style.width]="'90px'">
					<div *ngIf="!showSpinner">
						<span>Next</span>
					</div>
					<div *ngIf="showSpinner" class="loading-theme_white">
						<mat-spinner [diameter]="25"></mat-spinner>
					</div>
				</app-gradient-button>
			</div>
			<div class="button" style="margin-top: 21px" *ngIf="loginData.demoLoginEnabled">
				<app-gradient-button
					[disabled]="!loginData.demoUsername || !this.loginForm.get('password').value || !!(error$ | async)"
					[size]="'medium'"
					[cursor]="'pointer'"
					[hoverColor]="'#FFFFFF'"
					[minWidth]="'90px'"
					[minHeight]="'30px'"
					[fontSize]="'14px'"
					(buttonClick)="demoLogin()"
					[style.width]="'90px'">
					<div *ngIf="!showSpinner">
						<span>Sign in</span>
					</div>
					<div *ngIf="showSpinner" class="loading-theme_white">
						<mat-spinner [diameter]="25"></mat-spinner>
					</div>
				</app-gradient-button>
			</div>
		</div>
	</div>
</div>
